import { useEffect } from 'react';
import type { IndexOrderWorkData, WorkData } from '../dto/EntityRepository';
import { useEditMode } from './useEditMode';
import { useWorkIndexStore } from '../store/WorkIndexStore';
import { useWorkViewStore } from '../store/WorkViewStore';

export interface UseWorkIndexingResult {
  isIndexingMode: boolean;
  /** 인덱싱 순서 패널에 미저장 변경 여부 */
  isChanged: boolean;
  setIsIndexingMode: (enabled: boolean) => void;
  selectedIndexingWorkList: IndexOrderWorkData[];
  addSelectedIndexingWork: (work: WorkData) => void;
  mergeIndexingDropAtSlot: (draggedIds: string[], dropIndex: number) => void;
  removeSelectedIndexingWork: (id: string) => void;
  clearSelectedIndexingWorkList: () => void;
  clearWorkIndexingChangedFlag: () => void;
}

/**
 * Work 인덱싱 스토어 구독 + 편집 모드 종료 시 선택 목록 비움.
 */
export function useWorkIndexing(): UseWorkIndexingResult {
  const { isEditMode } = useEditMode();
  const isIndexingMode = useWorkIndexStore((s) => s.isIndexingMode);
  const isChanged = useWorkIndexStore((s) => s.isChanged);
  const setIsIndexingMode = useWorkIndexStore((s) => s.setIsIndexingMode);
  const selectedIndexingWorkList = useWorkIndexStore((s) => s.selectedIndexingWorkList);
  const addSelectedIndexingWork = useWorkIndexStore((s) => s.addSelectedIndexingWork);
  const mergeIndexingDropAtSlot = useWorkIndexStore((s) => s.mergeIndexingDropAtSlot);
  const removeSelectedIndexingWork = useWorkIndexStore((s) => s.removeSelectedIndexingWork);
  const clearSelectedIndexingWorkList = useWorkIndexStore((s) => s.clearSelectedIndexingWorkList);
  const clearWorkIndexingChangedFlag = useWorkIndexStore((s) => s.clearWorkIndexingChangedFlag);

  useEffect(() => {
    if (!isEditMode) clearSelectedIndexingWorkList();
  }, [isEditMode]);

  useEffect(() => {
    if (!isIndexingMode) return;
    useWorkViewStore.getState().clearActiveWork();
  }, [isIndexingMode]);

  return {
    isIndexingMode,
    isChanged,
    setIsIndexingMode,
    selectedIndexingWorkList,
    addSelectedIndexingWork,
    mergeIndexingDropAtSlot,
    removeSelectedIndexingWork,
    clearSelectedIndexingWorkList,
    clearWorkIndexingChangedFlag,
  };
}
